module.exports = __webpack_public_path__ + "img/football_player.44da13dc.png";